import { Typography } from './Typography';
import { styled } from './muiReexports';
/**
 * Intended to be used as the value for `noOptionsText` in Autocomplete-derived components.
 *
 * @example
 * <Autocomplete noOptionsText={<NoOptionsTypography>{t('nothing.is.found.label')}</NoOptionsTypography>} />
 */
export const NoOptionsTypography = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    color: theme.palette.text.muted,
}));
